import React, { useEffect, useState } from "react";

export function useBtnDisabled(data: any, condition: string[]) {
  const [isDisabled, setIsDisabled] = useState<boolean>(true);

  useEffect(() => {
    setIsDisabled(false);
    condition.some((conditionValue) => {
      if (!data[conditionValue]) {
        setIsDisabled(true);
      }
    });
  }, [data]);

  return isDisabled;
}
